module.exports = __webpack_public_path__ + "img/client-woman.ba5a5c57.jpg";